import { Modal, Button } from "react-bootstrap";

export default function DeleteModal({ show, onHide }) {
  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Body className="text-center">
        <h5>Are you sure?</h5>
        <p>This action cannot be undone</p>

        <Button variant="light" onClick={onHide} className="me-2">
          Cancel
        </Button>
        <Button variant="danger">Delete</Button>
      </Modal.Body>
    </Modal>
  );
}